import { useState } from 'react';

export default function useLogged() {
    const getLogged = () => {
        if (window.self !== window.top) {
            return true;
        }

        const logged = sessionStorage.getItem('labcodeLogged');

        return logged === 'true';
    };

    const [logged, setLogged] = useState(getLogged());

    const saveLogged = (logged: boolean) => {
        sessionStorage.setItem('labcodeLogged', String(logged));
        setLogged(logged);
    };

    return {
        setLogged: saveLogged,
        logged
    }
}
